import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import axios from 'axios'
import { AppUseDispatch, AppUseSelector } from '../../redux/hooks'
import {
  postHackChineseTokenForUser,
  removeHackChineseTokenForUser,
  removeSkritterTokenForUser,
} from '../../redux/actions/userAction'
import {
  ACCOUNT_REMOVE_HACK_CHINESE,
  ACCOUNT_REMOVE_SKRITTER,
  ACCOUNT_SET_HACK_CHINESE,
  ACCOUNT_SET_SKRITTER,
} from '../../redux/types'
import { getSkritterToken, handleSkritterLogin } from '../../services/skritter'
import CopyToClipboard from 'react-copy-to-clipboard'
import MAAYOT_API, { REACT_APP_HACK_CHINESE_APP_KEY } from '../../utils/config'

// Brand names stay as they are in every language.
const BEEMINDER = 'Beeminder'
const HACK_CHINESE = 'Hack Chinese'
const SKRITTER = 'Skritter'
// Invisible text that only holds the width of the status button the other rows have.
const HIDDEN_SPACER = 'Placeholder'

const Integrations: React.FC = () => {
  const { t } = useTranslation('account')
  const dispatch = AppUseDispatch()
  const { user_auth_token, skritter_token, credentials } = AppUseSelector((state: any) => state.user)
  const { memberId } = credentials
  const beeminderUrl = `${MAAYOT_API}tracking/streak/completed?memberId=${memberId}`
  const [token, setToken] = useState('')
  const [isOpen, setIsOpen] = useState<any>({
    beeminder: false,
    show: false,
    skritter: false,
  })

  const handleFormSubmit = async (e) => {
    e.preventDefault()

    try {
      const response = await axios.post(
        'https://www.hackchinese.com/establish_link_for_user',
        {
          user_auth_token: token,
        },
        {
          headers: {
            Authorization: REACT_APP_HACK_CHINESE_APP_KEY,
            'Content-Type': 'application/json',
          },
        },
      )
      if (response?.status === 200) {
        const result = await postHackChineseTokenForUser(token)
        if (result?.status === 200) {
          dispatch({ type: ACCOUNT_SET_HACK_CHINESE, payload: { token } })
        }
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const toggle = (name) => {
    setIsOpen({ ...isOpen, [name]: !isOpen[name] })
  }

  const removeHackChineseToken = async (e) => {
    e.preventDefault()
    const response = await removeHackChineseTokenForUser()
    if (response?.status === 200) {
      dispatch({ type: ACCOUNT_REMOVE_HACK_CHINESE })
    }
  }

  const handleSkritterConnect = () => {
    if (skritter_token) {
      removeSkritterTokenForUser().then(() => {
        dispatch({ type: ACCOUNT_REMOVE_SKRITTER, payload: {} })
        localStorage.removeItem('skritterData')
      })
    } else {
      handleSkritterLogin({ memberId })
    }
  }

  useEffect(() => {
    window.addEventListener('storage', () => {
      // this event will fire whenever the local storage is updated
      const newToken = getSkritterToken()
      if (skritter_token !== newToken?.skritter_token) {
        dispatch({ type: ACCOUNT_SET_SKRITTER, payload: { token: newToken?.skritter_token, skritter: newToken } })
      }
    })
    return () => {
      window.removeEventListener('storage', () => {
        //
      })
    }
  }, [])

  return (
    <>
      <h4 className='m-h4 m-gray-1'>{t('integrations.title')}</h4>
      <div className='correction-item'>
        <div className='w-row  w-d-flex section-story-content mb-20 '>
          <div className='w-col-12 w-col-medium-12 w-col-small-12 w-col-tiny-12 box-padding border-full border-radius-5 mb-15'>
            <div className='integration_box'>
              <div
                className='integration_box_item w-d-flex m-al-c m-sp-bw m-cursor-pointer'
                onClick={() => toggle('beeminder')}
              >
                <span className='box-title'>{BEEMINDER}</span>
                <div className='w-d-flex m-al-c'>
                  <div className='integration_btn' style={{ visibility: 'hidden' }}>
                    {HIDDEN_SPACER}
                  </div>
                  <span className='ml-10'>
                    <i className={`${isOpen.beeminder ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}`}></i>
                  </span>
                </div>
              </div>
              {isOpen.beeminder && (
                <div className='story-content intgration_content_padding border-top section-story'>
                  <h4 className='m-gray-1 intgration_content_title'>{t('integrations.syncWith', { app: BEEMINDER })}</h4>
                  <p className='item-title m-gray-1'>{t('integrations.beeminder.intro')}</p>

                  <>
                    <p className='item-title m-gray-1'>{t('integrations.steps')}</p>
                    <div className='token-points-div'>
                      <div className='membership-feature-item'>
                        <label className='num-text'>1</label>
                        <span className='m-sm-text'>{t('integrations.beeminder.step1')}</span>
                      </div>

                      <div className='token-form-div'>
                        <input
                          type='text'
                          className='input-custom-filed'
                          name='link'
                          id='link'
                          disabled
                          value={beeminderUrl}
                        />
                        <CopyToClipboard text={beeminderUrl}>
                          <button className='btn button-4 w-inline-block'>{t('integrations.copy')}</button>
                        </CopyToClipboard>
                      </div>

                      <div className='membership-feature-item'>
                        <label className='num-text'>2</label>
                        <span className='m-sm-text'>{t('integrations.beeminder.step2')}</span>
                      </div>
                      <div className='membership-feature-item'>
                        <label className='num-text'>3</label>
                        <span className='m-sm-text'>{t('integrations.beeminder.step3')}</span>
                      </div>
                      <div className='membership-feature-item'>
                        <i className='fa fa-info-circle mr-5' style={{ fontSize: '12px' }}></i>
                        <span className='m-sm-text'>{t('integrations.beeminder.tip')}</span>
                      </div>
                    </div>
                  </>
                </div>
              )}
            </div>
          </div>
          <div className='w-col-12 w-col-medium-12 w-col-small-12 w-col-tiny-12 box-padding border-full border-radius-5 mb-15'>
            <div className='integration_box'>
              <div
                className='integration_box_item w-d-flex m-al-c m-sp-bw m-cursor-pointer'
                onClick={() => toggle('show')}
              >
                <span className='box-title'>{HACK_CHINESE}</span>
                <div className='w-d-flex m-al-c'>
                  <button
                    className={`integration_btn color-white m-b-primary-2 border-radius-5 
                    ${user_auth_token ? ' connected-btn ' : ' not-connected '}
                    `}
                  >
                    {user_auth_token ? t('integrations.connected') : t('integrations.notConnected')}
                  </button>
                  <span className='ml-10'>
                    <i className={`${isOpen.show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}`}></i>
                  </span>
                </div>
              </div>
              {isOpen.show && (
                <div className='story-content intgration_content_padding border-top section-story'>
                  <h4 className='m-gray-1 intgration_content_title'>{t('integrations.syncWith', { app: HACK_CHINESE })}</h4>
                  <p className='item-title m-gray-1'>{t('integrations.hackChinese.intro')}</p>
                  {user_auth_token ? (
                    <>
                      <p className='item-title m-gray-1'>{t('integrations.hackChinese.linked')}</p>
                      <div className='token-points-div'>
                        <div className='membership-feature-item'>
                          <span className='m-sm-text'>{t('integrations.hackChinese.unlinkHint')}</span>
                        </div>
                        <div className='membership-feature-item'>
                          <button
                            className='sync_btn bg_transperent green_color border_green border-radius-5'
                            onClick={removeHackChineseToken}
                          >
                            {t('integrations.unlink')}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className='item-title m-gray-1'>{t('integrations.steps')}</p>
                      <div className='token-points-div'>
                        <div className='membership-feature-item'>
                          <label className='num-text'>1</label>
                          <span className='m-sm-text'>
                            <Trans
                              t={t}
                              i18nKey='integrations.hackChinese.step1'
                              values={{ app: HACK_CHINESE }}
                              components={[
                                <a key='link' href='https://www.hackchinese.com/sync-with-maayot' target='_blank' />,
                              ]}
                            />
                          </span>
                        </div>
                        <div className='membership-feature-item'>
                          <label className='num-text'>2</label>
                          <span className='m-sm-text'>{t('integrations.hackChinese.step2')}</span>
                        </div>
                        <div className='membership-feature-item'>
                          <label className='num-text'>3</label>
                          <span className='m-sm-text'>{t('integrations.hackChinese.step3')}</span>
                        </div>
                      </div>
                      <form onSubmit={handleFormSubmit}>
                        <div className='token-form-div'>
                          <input
                            pattern='([^:]{16})'
                            type='text'
                            className='input-custom-filed'
                            name='token'
                            id='token'
                            placeholder={t('integrations.hackChinese.tokenPlaceholder')}
                            onChange={(e) => {
                              setToken(e.target.value)
                            }}
                          />
                          <button
                            className='sync_btn bg_transperent green_color border_green border-radius-5'
                            type='submit'
                          >
                            {t('integrations.link')}
                          </button>
                        </div>
                      </form>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className='w-col-12 w-col-medium-12 w-col-small-12 w-col-tiny-12 box-padding border-full border-radius-5 mb-15'>
            <div className='integration_box'>
              <div
                className='integration_box_item w-d-flex m-al-c m-sp-bw m-cursor-pointer'
                onClick={() => toggle('skritter')}
              >
                <span className='box-title'>{SKRITTER}</span>
                <div className='w-d-flex m-al-c'>
                  <button
                    className={`integration_btn color-white m-b-primary-2 border-radius-5 
                    ${skritter_token ? ' connected-btn ' : ' not-connected '}
                    `}
                  >
                    {skritter_token ? t('integrations.connected') : t('integrations.notConnected')}
                  </button>
                  <span className='ml-10'>
                    <i className={`${isOpen.skritter ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}`}></i>
                  </span>
                </div>
              </div>
              {isOpen.skritter && (
                <div className='story-content intgration_content_padding border-top section-story'>
                  <h4 className='m-gray-1 intgration_content_title'> {t('integrations.syncWith', { app: SKRITTER })} </h4>
                  <p className='mb-20'>
                    <Trans
                      t={t}
                      i18nKey='integrations.skritter.intro'
                      values={{ app: SKRITTER }}
                      components={[<a key='link' href='https://skritter.com?ref=yjy1y2e' target='_blank' />]}
                    />
                  </p>
                  <button
                    onClick={handleSkritterConnect}
                    className='sync_btn bg_transperent green_color border_green border-radius-5'
                  >
                    {skritter_token ? t('integrations.unlink') : t('integrations.sync')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Integrations
